import React from 'react';

function EnergySourceCell(name: any) {
  if (name.text === "") {
    return (
      <div>
        {
          (name.data.numberOfProviders === 0 || name.data.numberOfProviders === -1) ? <></> :
            <><span className='bubble bubble-primary'></span>
              <span className='bubble bubble-secondary'></span></>
        }
        <span>{(name.data.numberOfProviders === 0 || name.data.numberOfProviders === -1) ? 'No Match' : `Multiple (${name.data.numberOfProviders})`}</span>
      </div>
    )
  } else if (name.text !== "") {
    return (
      <div>
        {(name.text !== 'Brown Energy' && name.text !== 'Energy Untraded') ? <span className='bubble bubble-primary'></span> : <span className='bubble bubble-secondary'></span>}
        <span>{name.text}</span>
      </div>
    )
  }
}
export default EnergySourceCell;